/* eslint-disable */
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AppShell from "../components/AppShell";
import MemberAvatar from "../components/MemberAvatar";
import { useAuth } from "../lib/auth";
import api from "../lib/api";
import { toast, Toaster } from "sonner";

function timeAgo(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const s = (Date.now() - d.getTime()) / 1000;
  if (s < 60) return "now";
  if (s < 3600) return `${Math.floor(s / 60)}m`;
  if (s < 86400) return `${Math.floor(s / 3600)}h`;
  if (s < 604800) return `${Math.floor(s / 86400)}d`;
  return d.toLocaleDateString(undefined, { month: "short", day: "numeric" });
}

export default function MessagesInbox() {
  const { user } = useAuth();
  const nav = useNavigate();
  const [threads, setThreads] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const r = await api.get("/community/messages/threads");
        if (!cancelled) setThreads(r.data?.threads || []);
      } catch (e) {
        toast.error(e?.response?.data?.detail || "Could not load messages");
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    load();
    const t = setInterval(load, 15000);
    return () => { cancelled = true; clearInterval(t); };
  }, []);

  return (
    <AppShell>
      <Toaster position="top-right" richColors />
      <section className="m-container" style={{ maxWidth: 720 }} data-testid="messages-inbox">
        <div style={{ display: "flex", alignItems: "baseline", justifyContent: "space-between", marginBottom: 20 }}>
          <div>
            <span className="m-eyebrow">Messages</span>
            <h1 className="m-h2" style={{ margin: "4px 0 0" }}>Direct messages</h1>
          </div>
          <Link to="/community" className="m-btn-ghost" style={{ padding: "6px 14px", fontSize: 12 }}>← Community</Link>
        </div>

        {loading ? (
          <div className="m-loading-inline">Loading conversations…</div>
        ) : threads.length === 0 ? (
          <div className="m-card" style={{ padding: 32, textAlign: "center" }} data-testid="messages-empty">
            <p className="m-muted">You don't have any conversations yet.</p>
            <p className="m-muted small" style={{ marginTop: 8 }}>
              Open a member's profile from the community feed to start a chat.
            </p>
          </div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            {threads.map((t) => (
              <Link
                key={t.thread_id}
                to={`/community/messages/${t.thread_id}`}
                data-testid={`inbox-thread-${t.thread_id}`}
                className="m-card"
                style={{
                  display: "flex", gap: 14, alignItems: "center",
                  padding: 18, textDecoration: "none", color: "inherit",
                  border: t.unread_count > 0 ? "1px solid var(--gold)" : "1px solid var(--m-border)",
                  background: t.unread_count > 0 ? "rgba(184,145,58,0.05)" : "#fff",
                  transition: "background 0.15s",
                }}
              >
                <MemberAvatar user={t.other} size={48} clickable={false} />
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ display: "flex", justifyContent: "space-between", gap: 8 }}>
                    <div style={{ fontWeight: t.unread_count > 0 ? 700 : 600 }}>
                      {t.other?.display_name || t.other?.name || "Member"}
                    </div>
                    <div className="m-muted small" style={{ whiteSpace: "nowrap" }}>
                      {timeAgo(t.last_message_at || t.created_at)}
                    </div>
                  </div>
                  <div style={{
                    color: t.unread_count > 0 ? "var(--m-text)" : "var(--m-muted)",
                    fontSize: 13, marginTop: 4,
                    overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
                    fontWeight: t.unread_count > 0 ? 500 : 400,
                  }}>
                    {t.last_message_sender_id === user?.user_id && "You: "}
                    {t.last_message_preview || <em style={{ opacity: 0.5 }}>No messages yet — say hi</em>}
                  </div>
                </div>
                {t.unread_count > 0 && (
                  <span
                    data-testid={`inbox-unread-${t.thread_id}`}
                    style={{
                      background: "var(--gold)", color: "#fff",
                      padding: "3px 10px", borderRadius: 999,
                      fontSize: 11, fontWeight: 700, letterSpacing: 0.12,
                    }}
                  >{t.unread_count}</span>
                )}
              </Link>
            ))}
          </div>
        )}
      </section>
    </AppShell>
  );
}
